import { ArrowUpRight, Gift, Sparkles, Star, Crown } from "lucide-react";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import Seo from "@/components/Seo";
import { OFFERS, BUSINESS } from "@/data/content";

const ICONS = [Sparkles, Star, Crown, Gift];

export default function Offers() {
  return (
    <div data-testid="offers-page">
      <Seo
        title="Offers & Rewards"
        path="/offers"
        description="Exclusive perks at Barrhaven Beauty Lounge — 15% off your first facial, monthly promotions, our Rewards Club and gift cards. Glow more, spend less."
      />
      <PageHero
        align="center"
        script="Offers & Rewards"
        title="Glow more, spend less."
        subtitle="Little luxuries, big love — exclusive perks, seasonal treats and loyalty rewards, just for you."
      />

      <section className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {OFFERS.map((o, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={o.title} delay={(i % 2) * 0.08}>
                <div
                  data-testid={`offer-${i}`}
                  className="group flex h-full flex-col rounded-2xl border border-black/10 bg-white p-10 md:p-12 transition-all duration-300 hover:-translate-y-1 hover:border-black/20 hover:shadow-[0_24px_60px_-24px_rgba(0,0,0,0.28)]"
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-14 w-14 items-center justify-center rounded-full bg-[#050505] text-white transition-transform duration-300 group-hover:scale-105">
                      <Icon size={24} strokeWidth={1.4} />
                    </span>
                    <span className="inline-block rounded-full bg-[#050505] px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-white">
                      {o.tag}
                    </span>
                  </div>
                  <h2 className="mt-8 font-serif-display text-3xl md:text-4xl tracking-tight text-[#050505]">
                    {o.title}
                  </h2>
                  <p className="mt-4 max-w-md text-base leading-relaxed text-[#3d3d3d]">
                    {o.detail}
                  </p>
                  <a
                    href={BUSINESS.bookingUrl}
                    target="_blank"
                    rel="noreferrer"
                    className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-[#050505]"
                  >
                    Claim offer
                    <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </a>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
